import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    position: 'relative',
    padding: 0
  },
  backgroundWrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: -1
  },
  backgroundImage: {
    width: '100%',
    height: '100%',
    
  //  objectFit: 'cover',
  
    //opacity: 0.1 // Watermark effect
  },
  contentWrapper: {
    position: 'relative',
    zIndex: -1,
    padding: 20
  },
  row: {
    flexDirection: 'row',
    marginBottom: 5
  },
  row1: {
    flexDirection: 'row',
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  contentContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    border: '1px solid black',
    padding: 10
  },
  contentContainer2: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 10
  },
  columnHeader: {
    width: '15%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center',
    marginTop: '2%'
  },
  columnContent: {
    width: '15%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const COLORS = ['#ffffff', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage {...props} size="A4" style={{ ...styles.page, ...style }}>
    <PDFView style={styles.backgroundWrapper}>
      <PDFImage src="/shriramhospital.png" style={styles.backgroundImage} />
    </PDFView>
    <PDFView style={styles.contentWrapper}>{children}</PDFView>
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const InvestigationBookingPdf = ({ data }) => {
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  const user = JSON.parse(localStorage.getItem('user'));
  const currentDate = new Date();
  const day = String(currentDate.getDate()).padStart(2, '0');
  const month = String(currentDate.getMonth() + 1).padStart(2, '0');
  const year = currentDate.getFullYear();
  const hours = String(currentDate.getHours()).padStart(2, '0');
  const minutes = String(currentDate.getMinutes()).padStart(2, '0');
  const seconds = String(currentDate.getSeconds()).padStart(2, '0');

  return (
    <PDFViewer width="100%" height="100%" showToolbar>
      <Document title="Investigation Booking">
        <Page>
          <View style={styles.row}>
            <Text content="Investigation Booking" style={{ fontSize: 12, marginTop:'15%', fontFamily: 'Roboto' }} />
          </View>

          {/* Patient Info */}
          <View style={styles.contentContainer}>
            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Reciept No   :   " style={styles.textBold} />
                <Text content={`${data.receiptNo}`} />
              </View>
              <View style={styles.row}>
                <Text content="Uhid No.       :   " style={styles.textBold} />
                <Text content={`${data.uhid}`} />
              </View>
              <View style={styles.row}>
                <Text content="Date/Time    :   " />
                <Text content={`${formatDate(data.billing_date)} ${data.billing_time}`} />
              </View>
              <View style={styles.row}>
                <Text content="Ref By          :   " />
                <Text content={`${data?.ref_by}`} />
              </View>
            </View>

            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Patient Name   :   " />
                <Text content={`${data.patientName}`} />
              </View>
              <View style={styles.row}>
                <Text content="Age/Sex           :    " />
                <Text content={`${data.age} / ${data.gender}`} />
              </View>
              <View style={styles.row}>
                <Text content="Mobile              :   " />
                <Text content={`${data.mobile}`} />
              </View>
              <View style={styles.row}>
                <Text content="Address           :   " />
                <Text content={`${data.address}`} />
              </View>
            </View>

            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Guardian       :   " />
                <Text content={`${data?.guardian}`} />
              </View>
              <View style={styles.row}>
                <Text content="Consultant     :   " />
                <Text content={`${data?.doctor}`} />
              </View>
              <View style={styles.row}>
                <Text content="Department   :   " />
                <Text content={`${data.department}`} />
              </View>
              <View style={styles.row}>
                <Text content="Sponsor         :   " />
                <Text content={`${data.sponsor}`} />
              </View>
            </View>
          </View>

          {/* Table Header */}
          <View style={styles.row1}>
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Sr No." />
            <Text style={{ ...styles.columnHeader, width: '35%' }} content="Services" />
            <Text style={{ ...styles.columnHeader, width: '5%' }} content="Qty" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Rate" />
            <Text style={{ ...styles.columnHeader, width: '15%' }} content="Amount" />
            <Text style={{ ...styles.columnHeader, width: '10%' }} content="Disc" />
            <Text style={{ ...styles.columnHeader, width: '15%' }} content="Net Amount" />
          </View>

          {/* Table Rows */}
          {data.services?.map((service, index) => (
            <View key={index} style={{ ...styles.row1, backgroundColor: COLORS[index % COLORS.length] }}>
              <Text style={{ ...styles.columnContent, width: '12%' }} content={index + 1} />
              <Text style={{ ...styles.columnContent, width: '35%', textAlign: 'left' }} content={service.service_name} />
              <Text style={{ ...styles.columnContent, width: '5%' }} content={`${service.quantity}`} />
              <Text style={{ ...styles.columnContent, width: '10%' }} content={service.rate} />
              <Text style={{ ...styles.columnContent, width: '15%' }} content={service.amount} />
              <Text style={{ ...styles.columnContent, width: '10%' }} content={service.disc_amt} />
              <Text style={{ ...styles.columnContent, width: '15%' }} content={service.net_amt} />
            </View>
          ))}

          {/* Footer Info */}
          <View style={styles.contentContainer2}>
            <View style={styles.column}>
              <View style={{ ...styles.row, marginTop: 20 }}>
                <Text content="Remarks  :    " style={styles.textBold} />
              </View>
              <View style={{ marginTop: 25 }}>
                <Text content={`Received With Thanks From : ${data.patientName}.`} />
              </View>
              <View style={{ marginTop: 5 }}>
                <Text content="Note : Refund if any, will be made against surrender of Original Receipt only !" />
              </View>
            </View>

            <View style={styles.column}>
              <View style={styles.row}>
                <Text content="Recd Amt  " />
                <Text content={`${data.pay_mode === 'CASH' ? `Cash : ${data.rec_amt_1}` : `Bank : ${data.rec_amt_2}`}`} />
              </View>
              <View style={{ ...styles.row, marginTop: 20 }}>
                <Text content="Printed By : " style={styles.textBold} />
                <Text content={user?.name} />
              </View>
            </View>

            <View style={{ width: '35%' }}>
              <View style={styles.row}>
                <Text content="Total Amount : " style={styles.textBold} />
                <Text content={`${data.total_amt}`} />
              </View>
              <View style={styles.row}>
                <Text content="Bill Discount : " style={styles.textBold} />
                <Text content={`${data.disc_amt}`} />
              </View>
              <View style={styles.row}>
                <Text content="Service Discount : " style={styles.textBold} />
                <Text content={`${data.service_disc}`} />
              </View>
              <View style={styles.row}>
                <Text content="Net Amt : " style={styles.textBold} />
                <Text content={`${data.net_amt}`} />
              </View>
              <View style={styles.row}>
                <Text content="Balance Amt : " style={styles.textBold} />
                <Text content={`${data.balance_amt}`} />
              </View>

              <View style={{ marginTop: 19 }}>
                <Text content="Received By     : " />
                <Text style={styles.textUnderlined} />
              </View>
              <View style={{ marginTop: 16 }}>
                <Text content="Authorised Signatory :" />
                <Text style={styles.textUnderlined} />
                <View style={{ marginTop: 10 }}>
                  <Text
                    content={`Printed Date and Time - ${day}/${month}/${year}, ${hours}:${minutes}:${seconds}`}
                    style={{ width: '180px' }}
                  />
                </View>
              </View>
            </View>
          </View>
        </Page>
      </Document>
    </PDFViewer>
  );
};
